import React from 'react';
import { Grid, Typography } from '@mui/material';

function MatrixCard(props) {
  const { matrix } = props;

  // Get the current URL pathname
  const currentPathname = window.location.pathname;

  // Extract the last name from the URL pathname
  const pathnameParts = currentPathname.split('/');
  const lastName = pathnameParts[pathnameParts.length - 1];

  // Define the desired last name
  const desiredLastName = 'detail';
  // Check if the last name matches the desired last name
  const isDesiredLastName = lastName === desiredLastName;
  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        columnGap={2}
        className={isDesiredLastName ? 'displayNone' : "displayBlock"}
      >
        <Grid item sx={{margin: "20px 0px"}}>
          <Typography variant={"body2"} className="fw400">Monthly Matrix</Typography>
        </Grid>
      </Grid>

      <Grid
        container
        direction='row'
        justifyContent='start'
        alignItems='center'
        sx={{marginTop: "30px"}}
        rowSpacing={2}
        gap={2}

      >
        {matrix && matrix.map((document) => (
          <Grid
            item
            container
            spacing={2}
            md={3.5}
            sm={4.7}
            xs={12}
            className="bgWhite p20"
            key={document.id}
          >
            <Grid item>
              <img src={document.icon} alt="wallet" />
            </Grid>
            <Grid item className='cardAlign'>
              <Typography variant={"head3"} component={"h1"} className="colorBlue fw500">{document.amt}</Typography>
              <Typography variant={"head5"} component={"h2"} className="colorBlack fw500"> {document.name}</Typography>
            </Grid>
          </Grid>

        ))}

      </Grid>


    </div>
  );
}

export default MatrixCard;
